import http from '@/http'

const PATH = '/tariffs'

export default {
    /**
     * @param {{params: {}}} data
     * @returns {Promise<void>}
     */
    async listAllTariffs ({params}) {
        try {
            const response = await http.get('/tariffs', {params})
            return response.data

        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{tariffId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listLegs ({tariffId, params}) {
        try {
            const response = await http.get(`${PATH}/${tariffId}`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
